module.exports = __webpack_public_path__ + "static/media/deadlines.d9f1c9f8.PNG";